import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SecondaryNav } from '@feathr/components';
import { useNavigation } from '@feathr/extender/state';

import DataNav from '../PrimaryNav/DataNav';

interface ICommunitySecondaryNavProps {
  className?: string;
}

function CommunitySecondaryNav({ className }: Readonly<ICommunitySecondaryNavProps>): JSX.Element {
  const { t } = useTranslation();
  const { setActiveSecondaryNav, scrollableRef } = useNavigation();

  const handleBack = (): void => {
    setActiveSecondaryNav(null);
  };

  return (
    <SecondaryNav
      className={className}
      onBack={handleBack}
      scrollableRef={scrollableRef}
      title={t('Community')}
    >
      <DataNav indented={false} />
    </SecondaryNav>
  );
}

export default CommunitySecondaryNav;
